import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import Fund from "src/app/interfaces/fund";
import OutletReviewStatus from "../../../interfaces/outlet-review-status";
import OutletReviewCategory from "../../../interfaces/outlet-review-category";
import { MatTableDataSource } from "@angular/material/table";
import OutletReviewTracker from "../../../interfaces/outlet-review-tracker";
import { DataFormatService } from "../../../services/data-format.service";
import ID from "../../../types/id";
import { TrackerTableItem } from "../review-timeline.component";
import { ReviewTimelineService } from "../review-timeline.service";
import { UpdateOutletReviewTrackerInput } from "../graphql/review-timeline";
import { Person } from "../../../interfaces/person";
import { formatDate } from "@angular/common";
import { debounceTime, Observable, Subject, Subscription } from "rxjs";
import Permission from "../../../interfaces/permission";


@Component({
    selector: 'timeline-tracker-section',
    templateUrl: './timeline-tracker-section.component.html',
    styleUrls: ['./timeline-tracker-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimelineTrackerSectionComponent {
  @Input('outletReviewStatuses') outletReviewStatuses: OutletReviewStatus[];
  @Input('outletReviewCategory') outletReviewCategory: OutletReviewCategory;
  @Input('outletReviewCategories') outletReviewCategories: OutletReviewCategory[];
  @Input('items')items: Observable<TrackerTableItem[]>;
  @Input('total') total: number;
  @Input('permission') permission: Permission|null;
  filteredTrackers: TrackerTableItem[]= [];
  dataSource: MatTableDataSource<TrackerTableItem> = new MatTableDataSource<TrackerTableItem>([]);
  columns = ["row",
    "project",
    "category",
    "city",
    "state",
    "sponsor",
    "equity",
    "percentage",
    "cumulative",
    "status",
    "cohn_reznick_review",
    "third_party_review_date",
    "crea_committee_memo_status",
    "report_distributed",
    "investment_committee_date",
    "close_date",
    "analyst_assignment"
  ];
  public sectionTotal: number = 0;
  public sectionTotalPercent: number = 0.0;
  private sub:Subscription;
  private dateChangeSubscription: Subscription;
  public dateChange = new Subject<{event:Event, tracker:ID, key:string}>()
  constructor(public dataFormat: DataFormatService, public trackerService: ReviewTimelineService) {
  }

  ngOnInit() {
    this.sub = this.items.subscribe((items)=>{
      this.filterItems(items);
    })
    this.dateChangeSubscription = this.dateChange.pipe(debounceTime(500)).subscribe(({event, tracker, key})=>{
      if((event.target as HTMLInputElement).value){
        this.updateField(tracker, key, (event.target as HTMLInputElement).value);
      }
    });
  }
  filterItems(items:TrackerTableItem[]) {
    if(items){
      this.filteredTrackers = items.filter(
        (item)=> item.outlet_review_category_id === this.outletReviewCategory.id
      );
      this.sectionTotal = 0.0;
      this.sectionTotalPercent = 0.0;
      for(let i = 0; i < this.filteredTrackers.length; i++){
        this.sectionTotal += this.filteredTrackers[i].equity ?? 0;
        this.sectionTotalPercent += this.filteredTrackers[i].percentage ?? 0;
      }
      this.dataSource.data = this.filteredTrackers;
    }
  }
  ngOnChange(){
  }
  updateField(tracker:ID, field:string, value:any){
    if(value?.target?.value){
      value = value.target.value
    }
    let input:UpdateOutletReviewTrackerInput = {};
    switch(field){
      case "outlet_review_category_id":
        input = {outlet_review_category_id: value as ID}
        break;
      case "outlet_review_analyst_id":
        input = {outlet_review_analyst_id: (value as Person)?.id ?? null}
        break;
      case "cohn_reznick_review_status_id":
        input = {cohn_reznick_review_status_id: value as ID}
        break;
      case "investor_committee_date":
        input = {investor_committee_date: formatDate(value as string, 'yyyy-MM-dd','en-US')}
        break;
      case "third_party_review_date_completed":
        input = {third_party_review_date_completed: formatDate(value as string, 'yyyy-MM-dd','en-US')}
        break;
      case "committee_memo_status_id":
        input = {committee_memo_status_id: value as ID}
        break;
      case "executive_report_distributed":
        input = {executive_report_distributed: value as boolean}
    }
    if(input){
      this.trackerService.updateOutletTimelineTracker(tracker, input);
    }
  }
}
